import DotsLoading from 'common-components/DotsLoading'
import { COLORS } from 'consts/colors'

import * as Styled from './styled'

interface IProps {
  transparent?: boolean
  className?: string
}

export const GlobalLoading: React.FC<IProps> = props => {
  return (
    <Styled.GlobalLoadingWrapper
      $isTransparent={props.transparent}
      className={props.className}
    >
      <DotsLoading dotColor={COLORS.primaryDark} size="small" />
    </Styled.GlobalLoadingWrapper>
  )
}
